import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import GetMyCardsNowButton from '../GetMyCardsNowButton'
import Steps from './Steps'

interface StepsSectionProps {
  onGetCardsClick: () => void
  showCompleteAccount?: boolean
  isSoftwareSection?: boolean
}

const StepsSection: React.FC<StepsSectionProps> = ({
  showCompleteAccount,
  isSoftwareSection,
  onGetCardsClick,
}) => {
  return (
    <Box
      className="steps"
      paddingX="s64"
      paddingY="s32"
      width="full"
      flexDirection="column"
      gap="s64"
    >
      <Box className="steps__section-header" flexDirection="row" justifyContent="spaceAround">
        <Box flexDirection="column" gap="s8" maxWidth="s400" textAlign="center">
          <Text.Header2 htmlTag="h2">
            {i18n.t('expenses_v2.cards.blocks.steps_section.title')}
          </Text.Header2>
          <Text.Normal>{i18n.t('expenses_v2.cards.blocks.steps_section.subtitle')}</Text.Normal>
        </Box>
      </Box>
      <Box>
        <Steps isSoftwareSection={isSoftwareSection} />
      </Box>
      <Box flexDirection="column" alignItems="center" gap="s8">
        <GetMyCardsNowButton showCompleteAccount={showCompleteAccount} onClick={onGetCardsClick} />
      </Box>
    </Box>
  )
}

export default StepsSection
